function isPromise(object) {
    var isObjectOrFunction = (typeof object === 'object' && object !== null) || typeof object === 'function';
    return isObjectOrFunction && typeof object.then === "function";
}
function isPromiseOrContainsPromise(object) {
    if (isPromise(object)) {
        return true;
    }
    return Array.isArray(object) && object.some(isPromise);
}
export { isPromise, isPromiseOrContainsPromise };
//# sourceMappingURL=async.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/utils/async.js
// module id = 402
// module chunks = 0